<template>
  <div class="pd-y-5 text-left">
    <viewer v-if="description" :initialValue="description" class="mg-t-3 text-font-16" />
    <p v-else>- ไม่มีคำอธิบายหลักสูตร -</p>
    <div class="pd-b-4">
      <a
        v-for="(item, index) in fileList"
        :key="index"
        :href="`${urlCouse}${id}/${item.file}`"
        class="color-primary"
        target="blank"
        style="display: block"
      >
        <i
          :class="`fas ${getFileIcon(item.type).name} text-font-16`"
          :style="`color:${getFileIcon(item.type).color}`"
        ></i>
        <span class="text-font-12 pd-l-5">{{
          item.default ? item.default : item.file
        }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import "@toast-ui/editor/dist/toastui-editor-viewer.css";

import { Viewer } from "@toast-ui/vue-editor";
import { getFileIcon } from "@/service/file";

export default {
  components: {
    viewer: Viewer,
  },
  props: {
    id: {
      type: String,
      default() {
        return "";
      },
    },
    description: {
      type: String,
      default() {
        return "";
      },
    },
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
    };
  },
};
</script>
